var map = {
	"./template.bet575": 2064,
	"./template.bet575.tsx": 2064,
	"./template.bet777": 2065,
	"./template.bet777.tsx": 2065,
	"./template.betprofessor": 2066,
	"./template.betprofessor.tsx": 2066,
	"./template.betroyale": 2067,
	"./template.betroyale.tsx": 2067,
	"./template.betstride": 2068,
	"./template.betstride.tsx": 2068,
	"./template.buffalobet": 2069,
	"./template.buffalobet.tsx": 2069,
	"./template.chromabet": 2070,
	"./template.chromabet.tsx": 2070,
	"./template.default": 670,
	"./template.default.tsx": 670,
	"./template.epicodds": 2071,
	"./template.epicodds.tsx": 2071,
	"./template.fiestabet": 2072,
	"./template.fiestabet.tsx": 2072,
	"./template.forsport": 1628,
	"./template.forsport.tsx": 1628,
	"./template.gigabet": 2073,
	"./template.gigabet.tsx": 2073,
	"./template.goldenbet888": 2074,
	"./template.goldenbet888.tsx": 2074,
	"./template.goldenrush": 2075,
	"./template.goldenrush.tsx": 2075,
	"./template.hyperbet": 2076,
	"./template.hyperbet.tsx": 2076,
	"./template.juicybet": 2077,
	"./template.juicybet.tsx": 2077,
	"./template.junglebet": 2078,
	"./template.junglebet.tsx": 2078,
	"./template.magnumbet": 2079,
	"./template.magnumbet.tsx": 2079,
	"./template.oldgill": 2080,
	"./template.oldgill.tsx": 2080,
	"./template.puntcity": 2081,
	"./template.puntcity.tsx": 2081,
	"./template.puntgenie": 2082,
	"./template.puntgenie.tsx": 2082,
	"./template.pyramidbet": 2083,
	"./template.pyramidbet.tsx": 2083,
	"./template.questbet": 2084,
	"./template.questbet.tsx": 2084,
	"./template.slambet": 2085,
	"./template.slambet.tsx": 2085,
	"./template.sterlingparker": 2086,
	"./template.sterlingparker.tsx": 2086,
	"./template.sugarcastle": 2087,
	"./template.sugarcastle.tsx": 2087,
	"./template.templebet": 2088,
	"./template.templebet.tsx": 2088,
	"./template.titanbet": 2089,
	"./template.titanbet.tsx": 2089,
	"./template.ts": 983,
	"./template.vikingbet": 2090,
	"./template.vikingbet.tsx": 2090,
	"./template.volcanobet": 2091,
	"./template.volcanobet.tsx": 2091,
	"./template.wellbet": 2092,
	"./template.wellbet.tsx": 2092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2466;